if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      // 初始化元素，带有容错判断
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };


      // 绑定按钮事件（前提是元素存在）
      if (this.elements.button && this.elements.panel) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      }

      // 整个容器监听键盘事件（如 ESC 关闭）
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      // 给下拉列表项绑定点击事件
      this.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });
    }

    // 显示面板
    openSelector() {
      if (!this.elements.button || !this.elements.panel) return;

      this.elements.button.focus();
      const isHidden = this.elements.panel.hasAttribute('hidden');

      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (!isHidden).toString());
    }

    // 隐藏面板
    hidePanel() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    // 按 ESC 时关闭
    onContainerKeyUp(event) {
      if (event.code?.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      if (this.elements.button) {
        this.elements.button.focus();
      }
    }

    // 点击某个选项时，更新 input 并提交表单
    onItemClick(event) {
      event.preventDefault();

      const form = this.querySelector('form');
      const value = event.currentTarget?.dataset?.value;

      if (this.elements.input && value) {
        this.elements.input.value = value;
        if (form) form.submit();
      }
    }

    // 焦点离开选择器时关闭（确保不是点击内部元素）
    closeSelector(event) {
      const related = event.relatedTarget;
      if (
        !related ||
        (this.elements.panel && this.elements.panel.contains(related)) ||
        (this.elements.button && this.elements.button.contains(related))
      ) {
        return;
      }
      this.hidePanel();
    }
  });
}
